import { render, staticRenderFns } from "./model.vue?vue&type=template&id=2f7256f5&scoped=true&"
import script from "./model.vue?vue&type=script&lang=js&"
export * from "./model.vue?vue&type=script&lang=js&"
import style0 from "./model.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./model.vue?vue&type=style&index=1&id=2f7256f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7256f5",
  null
  
)

export default component.exports